import { useDispatch, useSelector } from 'react-redux'

import { Translation } from '@/components/i18n/Translation'
import { DispatchTabs } from '@/components/util/Tabs'
import { getStatusCounter, getStatusFilter, setStatusFilter } from '@/ducks/shopOrdersReducer'
import { numberFormat } from '@/util/formatters/numbers'
import { getShopOrderStatusTextId } from '@/util/orders'

const StatusTabs = () => {
  const dispatch = useDispatch()

  const statusCounter = useSelector(getStatusCounter)
  const statusFilter = useSelector(getStatusFilter)
  // @ts-ignore
  const sortFn = (x, y) => x - y
  const keys = Object.keys(statusCounter)
    .map(key => parseInt(key))
    .sort(sortFn)

  const tabs = keys.map(status => ({
    onClick: () => dispatch(setStatusFilter(status)),
    selected: statusFilter === status,
    children: (
      <>
        <Translation id={getShopOrderStatusTextId(status)} />{' '}
        <b>{numberFormat(statusCounter[status])}</b>
      </>
    ),
  }))
  // @ts-ignore
  return <DispatchTabs className="status-tabs" tabs={tabs} />
}

export default StatusTabs
